/**
 * 현장 사이트 링크 API 클라이언트.
 * 백엔드 /v0.1/site-management/projects/:id/links + /links/:id 와 1:1 매칭.
 *
 * 운영팀 요청: 2 필드만 — 이름 / URL. 개요의 현장 담당자 바로 아래에 노출되며
 * 클릭하면 해당 URL 로 이동.
 */
import { API_ENDPOINTS } from '../config/api';
import { apiClient } from './api/apiClient';
import {
  ApiItemResponse,
  ApiListResponse,
  ApiOkResponse,
  ensureOk,
  unwrapItem,
  unwrapList,
} from './api/response';

export interface SiteLink {
  id: number;
  site_project_id: number;
  name: string;
  url: string;
  created_at: string;
  updated_at: string;
}

export interface CreateSiteLinkRequest {
  name: string;
  url: string;
}

export interface UpdateSiteLinkRequest {
  name?: string;
  url?: string;
}

export class SiteLinkService {
  static async list(projectId: number): Promise<SiteLink[]> {
    const resp = await apiClient.get<ApiListResponse<SiteLink>>(API_ENDPOINTS.SITE_MANAGEMENT.LINKS.LIST(projectId));
    return unwrapList(resp, '사이트 링크 목록 조회 실패');
  }

  static async create(projectId: number, data: CreateSiteLinkRequest): Promise<SiteLink> {
    const resp = await apiClient.post<ApiItemResponse<SiteLink>>(API_ENDPOINTS.SITE_MANAGEMENT.LINKS.CREATE(projectId), data);
    return unwrapItem(resp, '사이트 링크 등록 실패');
  }

  static async update(linkId: number, data: UpdateSiteLinkRequest): Promise<SiteLink> {
    const resp = await apiClient.put<ApiItemResponse<SiteLink>>(API_ENDPOINTS.SITE_MANAGEMENT.LINKS.UPDATE(linkId), data);
    return unwrapItem(resp, '사이트 링크 수정 실패');
  }

  static async delete(linkId: number): Promise<void> {
    const resp = await apiClient.delete<ApiOkResponse>(API_ENDPOINTS.SITE_MANAGEMENT.LINKS.DELETE(linkId));
    ensureOk(resp, '사이트 링크 삭제 실패');
  }
}
